module.exports = __webpack_public_path__ + "static/img/banner_1.d1ab2fcc.webp";